import { useMutation } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";

const deleteObservationAnswer = async (id: number) => {
	const url = `/observations/admin/answers/${id}/`;

	const response = await cmsClient.delete(url);
	return response.data;
};

const useDeleteObservationAnswer = () => {
	const mutation = useMutation(deleteObservationAnswer);
	return mutation;
};

export default useDeleteObservationAnswer;
